import * as React from 'react';
import { useRecordContext } from 'react-admin';
import playerPlaceholder from '../assets/player-placeholder.svg';
import { getPlayerPhotoUrl } from './playerViewModel';

const Photo = ({ record, size = 54, className = '' }) => {
  const src = getPlayerPhotoUrl(record, undefined, 'thumbnail') || playerPlaceholder;
  return (
    <img
      className={`fs-player-photo ${className}`.trim()}
      src={src}
      alt={record ? `${record.lastname || ''} ${record.firstname || ''}`.trim() : 'Футболист'}
      style={{ width: size, height: size }}
      onError={(event) => {
        if (event.currentTarget.src !== playerPlaceholder) event.currentTarget.src = playerPlaceholder;
      }}
    />
  );
};

export const PlayerIdentityField = (props) => {
  const record = useRecordContext(props);
  if (!record) return null;
  return (
    <div className="fs-player-identity">
      <Photo record={record} />
      <div className="fs-player-identity__text">
        <strong>{[record.lastname, record.firstname].filter(Boolean).join(' ') || 'Без имени'}</strong>
        <span>{record.f_email || `ID ${record.id}`}</span>
      </div>
    </div>
  );
};

export const PlayerDetailsField = (props) => {
  const record = useRecordContext(props);
  if (!record) return null;
  return (
    <div className="fs-player-details-cell">
      <strong>{record.team || 'Команда не указана'}</strong>
      <span>{record.playerPosition || 'Позиция не указана'}</span>
      {record.lead_leg ? <small>Нога: {record.lead_leg}</small> : null}
    </div>
  );
};

export const PlayerStatusField = (props) => {
  const record = useRecordContext(props);
  if (!record) return null;
  const active = Boolean(record.Active);
  return <span className={`fs-status-badge ${active ? 'is-active' : 'is-inactive'}`}>{active ? 'Активный' : 'Неактивный'}</span>;
};

export const PlayerAvatarImage = ({ record, size = 70, className = '' }) => <Photo record={record} size={size} className={className} />;
